import { cn } from '@shigo-ui/ui';

export function dashboardPageTitleClassName(className?: string) {
  return cn('text-foreground text-2xl leading-tight font-semibold tracking-tight', className);
}
